/* Milaros – Produktempfehlungen auf der Produktseite
   Reihe 1 „Mehr aus dieser Serie“: Einzelmodule, gleiche Serie + gleiche Farbe/Dekor (bis 15).
   Reihe 2 „Das könnte auch passen“: Sets derselben Serie (P1 gleiches Modell andere Farbe,
   P2 ähnliche Breite andere Farbe, P3 übrige Modelle), bis 12.
   Datenquelle nur Lesezugriffe: Titel (Hauptquelle), Farbe-Option (Bestätigung), Beschreibung (Breite).
   Netzwerk: 1–2 Feed-Anfragen (JSON, `title:<Serie>`) + 1 Karten-Anfrage (`id:… OR id:…`).
   Resolver-Funktionen sind rein (ohne DOM) und in Node testbar: module.exports = MilarosRel. */
(function (global, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.MilarosRel = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  /* ── Titel → Serie, Linie, Farbsegment ─────────────────────────────── */
  var SEP = /\s+[-–,]\s*|\s*[-–,]\s+|\s–|–\s/;
  var TYPEW = /(schrank|schränke|schränk|set|möbel|regal|küche|zeile|block|platte|blende|blenden|front|fronten|leiste|becken|tisch|kommode|spiegel|vitrine)$/i;
  var STOP = /^(für|mit|und|von|das|die|der|den|dem|ein|eine|einen|ihre|ihr|jeden|zu|auf|in|ohne)$/i;
  function isCode(t) { return /^([IVX]{1,4}|[A-Z]\/?|cm|mm|AX|[A-Z]{1,2}|[A-Z](\/[A-Z])+)$/.test(t) || /\d/.test(t); }
  function cap(t) { return /^[A-ZÄÖÜ]/.test(t); }
  function toks(s) { return String(s || '').split(/\s+/).filter(Boolean); }
  function serieOk(tk) {
    tk = tk.filter(function (x) { return x !== '/'; });
    return tk.length > 0 && tk.length <= 5 && !/\.$/.test(tk[tk.length - 1]) &&
      !tk.some(function (x) { return STOP.test(x); }) && !TYPEW.test(tk[0]);
  }
  // „Sycylia Milano für die Küche …“ → „Sycylia Milano“ (nur großgeschriebene Wörter vor dem Stoppwort)
  function serieLead(tk) {
    var out = [];
    for (var i = 0; i < tk.length && !STOP.test(tk[i]); i++) out.push(tk[i]);
    return out.length && out.length <= 3 && out.length < tk.length && out.every(cap) && !TYPEW.test(out[0]) ? out : null;
  }
  function colourLike(s) {
    s = (s || '').trim();
    if (!s || /\.$/.test(s) || /\d/.test(s)) return false;
    var w = s.split(/[\s\/]+/).filter(Boolean);
    return w.length > 0 && w.length <= 6 && w.every(function (x) { return cap(x) || /^(matt|hochglanz|glanz|geölt|natur)$/i.test(x); });
  }
  function parseTitle(title) {
    var t = String(title || '').trim().replace(/\s+-(?=Set\b)/g, '-');
    var m = t.match(/\(([^()]*\s-\s[^()]*)\)/);
    if (m) t = 'X - ' + m[1].split(' - ').pop().trim();
    var segs = t.split(SEP).map(function (s) { return s.trim(); }).filter(Boolean);
    var out = { serie: '', raw: '', line: [], detail: '', segs: segs };
    if (!segs.length) return out;
    var s0 = toks(segs[0]), ser = null, idx = 0, i;
    for (i = 0; i < s0.length && !isCode(s0[i]); i++) {}
    if (i < s0.length) {
      var after = s0.slice(i + 1).filter(function (x) { return !isCode(x); });
      if (after.length && cap(after[0]) && serieOk(after)) ser = after;
    }
    if (!ser) {
      var caps = s0.slice(1).filter(function (x) { return /^[A-ZÄÖÜ]{3,}$/.test(x) && !TYPEW.test(x); });
      if (caps.length) ser = caps.slice(0, 1);
    }
    if (!ser) {
      for (i = 1; i < segs.length; i++) {
        var tk = toks(segs[i]).filter(function (x) { return !isCode(x); });
        if (serieOk(tk)) { ser = tk; idx = i; break; }
        var lead = serieLead(tk);
        if (lead) { ser = lead; idx = i; break; }
      }
    }
    if (!ser) return out;
    out.raw = ser[0];
    out.serie = ser[0].toLowerCase();
    var rest = ser.slice(1), k = -1;
    for (i = 0; i < rest.length; i++) if (rest[i].indexOf('/') >= 0) { k = i; break; }
    if (k >= 0) {
      while (k > 0 && cap(rest[k - 1]) && !isCode(rest[k - 1])) k--;   // „Sonoma Eiche/Weiß“ ganz zur Farbe
      out.detail = rest.slice(k).join(' ');
      rest = rest.slice(0, k);
    }
    out.line = rest.filter(function (x) { return x !== '/'; });
    if (!out.detail && idx + 1 < segs.length && colourLike(segs[idx + 1])) out.detail = segs[idx + 1];
    return out;
  }

  /* ── Farbe/Dekor-Identität ─────────────────────────────────────────── */
  var SYN = {
    oak: 'eiche', white: 'weiß', weiss: 'weiß', weis: 'weiß', black: 'schwarz', grey: 'grau', gray: 'grau',
    green: 'grün', grun: 'grün', cashmere: 'kaschmir', kashmir: 'kaschmir', antique: 'antik', antike: 'antik',
    graphite: 'graphit', artsian: 'artisan', walnut: 'nussbaum', nuss: 'nussbaum', pine: 'kiefer', beech: 'buche',
    ash: 'esche', anthracite: 'anthrazit', cream: 'creme', rosa: 'rose', dunkle: 'dunkel', dunkler: 'dunkel',
    dunkles: 'dunkel', dark: 'dunkel', helle: 'hell', heller: 'hell', helles: 'hell', light: 'hell',
    marble: 'marmor', concrete: 'beton', walnuss: 'nussbaum', 'geölte': 'geölt', 'geölter': 'geölt', oiled: 'geölt'
  };
  // Mehrwort-Synonyme (EN → DE), vor dem Zerlegen
  var PHRASE = [[/\breed\s+gr(ü|ue|u)n\b|\breed\s+green\b/g, 'schilfgrün']];
  var HEAD = /^(weiß|schwarz|grau|beige|grün|schilfgrün|blau|rot|gelb|anthrazit|kaschmir|taupe|creme|sand|rose|braun|silber|gold|graphit|oliv|petrol|mint|hellgrau|dunkelgrau|eiche|nussbaum|kiefer|buche|esche|akazie|marmor|beton|pinie|ulme|kirsche)$/;
  var WOOD = /^(eiche|nussbaum|kiefer|buche|esche|akazie|pinie|ulme|kirsche)$/;
  var FIN = /^(matt|hochglanz|glanz|seidenmatt|satin|und|mit|soft|touch|x)$/;
  var POSTQ = /^(geölt|natur|massiv|gebürstet)$/;
  // Farbwörter, die direkt vor einem Holz ein Dekor bilden („Gold Eiche“ = Golden Oak)
  var DECORQ = /^(gold|golden|grau|weiß|schwarz)$/;
  function words(s) {
    var t = String(s || '').toLowerCase();
    PHRASE.forEach(function (r) { t = t.replace(r[0], r[1]); });
    return t
      .replace(/(\S{3,}?)(matt|hochglanz)\b/g, '$1 $2')
      .replace(/\s*[\/,+&]\s*/g, ' | ')
      .split(/[\s\-–()]+/)
      .map(function (w) { return SYN[w] || w; })
      .filter(function (w) { return w === '|' || (w.length > 1 && !/\d/.test(w) && !FIN.test(w)); });
  }
  function components(s, nameWords) {
    var ws = words(s).filter(function (w) { return !nameWords || nameWords.indexOf(w) < 0; });
    var comps = [], buf = [];
    ws.forEach(function (w, i) {
      if (w === '|') { if (buf.length) comps.push(buf.join(' ')); buf = []; return; }
      if (DECORQ.test(w) && i + 1 < ws.length && WOOD.test(ws[i + 1])) { buf.push(w); return; }
      if (POSTQ.test(w) && !buf.length && comps.length && WOOD.test(comps[comps.length - 1])) {
        comps[comps.length - 1] = w + ' ' + comps[comps.length - 1];
        return;
      }
      if (HEAD.test(w)) {
        comps.push(WOOD.test(w) || buf.length ? buf.concat(w).join(' ') : w);
        buf = [];
      } else buf.push(w);
    });
    // Nachgestellter Zusatz („Eiche geölt“) gehört zum Holz davor → „geölt eiche“
    if (buf.length && comps.length && WOOD.test(comps[comps.length - 1])) comps[comps.length - 1] = buf.join(' ') + ' ' + comps[comps.length - 1];
    else if (buf.length) comps.push(buf.join(' '));
    // „eiche“ ohne Zusatz ist redundant, wenn eine benannte Eiche dabei ist
    var named = comps.some(function (c) { return / eiche$/.test(c); });
    var out = [];
    comps.forEach(function (c) {
      var hasHead = c.split(' ').some(function (x) { return HEAD.test(x); });
      if (hasHead && (c !== 'eiche' || !named) && out.indexOf(c) < 0) out.push(c);
    });
    return out;
  }
  // Unbenannte „Eiche“ ≙ „dunkel eiche“ (Bildvergleich Sorento), nie Sonoma/Artisan/…
  function compat(a, b) {
    return a === b || (a === 'eiche' && b === 'dunkel eiche') || (b === 'eiche' && a === 'dunkel eiche');
  }
  function refines(a, b) { return compat(a, b) || (a === 'eiche' && / eiche$/.test(b)); }
  function subsetLoose(a, b) { return a.length > 0 && a.every(function (x) { return b.some(function (y) { return refines(x, y); }); }); }
  function subset(a, b) { return a.length > 0 && a.every(function (x) { return b.some(function (y) { return compat(x, y); }); }); }
  function sameSet(a, b) { return subset(a, b) && subset(b, a); }
  // Reihenfolge zählt: „Weiß / Sonoma Eiche“ (weiße Front) ≠ „Sonoma Eiche / Weiß“ (Eichenfront, weißer Korpus)
  function seqEq(a, b) { return a.length > 0 && a.length === b.length && a.every(function (x, i) { return compat(x, b[i]); }); }

  /* ── Art, Modell, Maße ─────────────────────────────────────────────── */
  var SET_WORD = /^(küchenzeile|winkelküche|küchenblock|einbauküche|l-küche|u-küche|küche|komplettküche)(?![a-zäöüß])/i;   // auch „Küchenzeile320x160“
  // Front-/Blendenteile: maßgeblich ist nur die Frontfarbe (Farbe-Option, per Bildnamen belegt: F.Bialy = Weiß …)
  var FRONT = /^(frontblende|front|fronten|blende|sockelblende|geschirrspül\w*)$/i;
  var MODULE_WORD = /(schrank|schränke|blende|front|fronten|leiste|platte|regal|spiegel|becken|kommode|vitrine|tisch|sockel|korpus|griff)/i;
  function kindOf(title, type) {
    var t = String(title || '').trim();
    if (SET_WORD.test(t)) return 'set';
    if (/(^|[\s-])[Ss]et(?![a-zäöüß])/.test(t) || /\bkomplett/i.test(t)) return 'set';   // auch „SetBM247“ (ohne i-Flag)
    if (MODULE_WORD.test(t.split(SEP)[0])) return 'module';                   // „Küchen Sockelleiste“ trotz Typ „Küchen“
    if (/^(küchen|küchenzeilen)$/i.test(String(type || '').trim())) return 'set';
    return 'module';
  }
  function modelOf(title) {
    var t = String(title || ''), m;
    if ((m = t.match(/\b([A-Z]{1,3}\d{1,3}[A-Z]?)-M(\d{3})\b/))) return { code: m[0], family: m[1], width: +m[2] };
    if ((m = t.match(/\bBM\s?-?(\d{1,3})\b/))) return { code: 'BM' + m[1], family: 'BM' + m[1], width: 0 };
    if ((m = t.match(/\b([A-ZÄÖÜ]{3,})\s+(\d{1,3})\b/))) return { code: m[1] + ' ' + m[2], family: m[1], width: 0 };
    return { code: '', family: '', width: 0 };
  }
  function widthOf(title, breite, desc) {
    var t = String(title || ''), m;
    if ((m = t.match(/(\d{2,4}(?:[.,]\d)?)\s*[x×]\s*\d{2,4}/))) return Math.round(parseFloat(m[1].replace(',', '.')));
    if ((m = t.match(/-M(\d{3})\b/))) return +m[1];
    if ((m = t.match(/\b(\d{2,3})\s*cm\b/))) return +m[1];
    if ((m = String(breite || '').match(/(\d{2,4}(?:[.,]\d)?)/))) return Math.round(parseFloat(m[1].replace(',', '.')));
    // Beschreibung (nur Sets): erste Breite „80 cm“, Einzelteil-Maße „35 x 170 x 33 cm“ überspringen
    var d = String(desc || '').replace(/\d+(?:[.,]\d+)?\s*[x×]\s*\d+(?:[.,]\d+)?(?:\s*[x×]\s*\d+(?:[.,]\d+)?)?\s*cm/g, ' ');
    if ((m = d.match(/\b(\d{2,3})\s*cm\b/))) return +m[1];
    return 0;
  }

  /* ── Produkt analysieren ───────────────────────────────────────────── */
  // p = { id, handle, title, type, available, colours: [Farbe-Optionswerte], breite, desc (nur Sets) }
  function analyse(p, nameWords) {
    var t = parseTitle(p.title);
    nameWords = (nameWords || []).concat(t.serie ? words(t.raw) : []);
    var L = components(t.line.join(' '), nameWords);
    var D = components(t.detail, nameWords);
    var T = components(L.concat(D).join(' / '), nameWords);
    var opts = (p.colours || []).filter(Boolean).map(function (v) { return components(v, nameWords); })
      .filter(function (c) { return c.length; });
    var id = T, alts = null, src = 'titel', conflict = false;
    var front = FRONT.test(toks(p.title)[0] || '');
    if (front && opts.length === 1) { id = opts[0]; src = 'option (Frontfarbe)'; }
    else if (opts.length === 1) {
      var O = opts[0];
      if (!T.length) { id = O; src = 'option'; }
      else if (subsetLoose(T, O)) { id = O; src = 'titel+option'; }     // Option vollständiger/präziser (auch Reihenfolge)
      else if (subset(O, T)) { src = 'titel (Option bestätigt)'; }      // Titel vollständiger
      else if (T.some(function (x) { return O.some(function (y) { return compat(x, y); }); })) src = 'titel (Option teilweise)';
      else conflict = true;                                                // nichts gemeinsam → unsicher
    } else if (opts.length > 1 && !T.length) { alts = opts; id = []; src = 'varianten'; }
    var mo = modelOf(p.title);
    return {
      p: p, front: front, serie: t.serie, raw: t.raw, lineWords: t.line.map(function (w) { return w.toLowerCase(); }),
      lineKey: words(t.line.join(' ')).filter(function (w) { return w !== '|' && (!nameWords || nameWords.indexOf(w) < 0); })
        .filter(function (w, i, a) { return a.indexOf(w) === i; }).sort().join(' '),
      line: L, id: id, alts: alts, src: src, conflict: conflict,
      finish: finishOf(t.line.join(' ') + ' ' + t.detail) || (opts.length === 1 ? finishOf((p.colours || [])[0]) : ''),
      kind: kindOf(p.title, p.type), model: mo.code, family: mo.family,
      width: mo.width || widthOf(p.title, p.breite, p.desc), typeWord: (toks(p.title)[0] || '').toLowerCase()
    };
  }
  // Wörter, die in ≥80 % der Serie im Serien-Segment stehen, sind Namensteile („Fe“, „Milano“), keine Farbe.
  function nameWordsOf(list, serie) {
    var own = list.filter(function (a) { return a.serie === serie; });
    if (own.length < 3) return [];
    var cnt = {};
    own.forEach(function (a) {
      var seen = {};
      words(a.lineWords.join(' ')).forEach(function (w) { if (!seen[w]) { seen[w] = 1; cnt[w] = (cnt[w] || 0) + 1; } });
    });
    return Object.keys(cnt).filter(function (w) { return cnt[w] / own.length >= 0.8 && !HEAD.test(w); });
  }
  function finishOf(s) {
    var t = String(s || '').toLowerCase();
    return /hochglanz|high\s*gloss/.test(t) ? 'hochglanz' : /\bmatt|matt\b/.test(t) ? 'matt' : '';
  }
  function normTitle(s) { return String(s || '').toLowerCase().replace(/[\s\-–,]+/g, ' ').trim(); }

  /* ── Auswahl ───────────────────────────────────────────────────────── */
  // loose = Set einer Serie mit einfarbigen Modulen (Langen: Küche aus „Artisan Eiche“- und „Beige“-Modulen)
  function colourMatch(c, me, loose) {
    if (c.conflict || me.conflict) return false;
    if (me.finish && c.finish && me.finish !== c.finish) return false;
    if (me.id.length && c.id.length) {
      if (seqEq(c.id, me.id)) return true;
      // Frontteil passt, wenn seine Farbe die Frontfarbe (erste Komponente) des aktuellen Produkts ist
      // … und seine Linie im Titel („Sorento Sonoma Eiche Weiß“) nennt genau die Farben des aktuellen Produkts.
      // Sonst käme z. B. die weiße Landhaus-Front der Linie „Weiß / Sonoma“ auf „Weiß / Grün“-Seiten (weißer Korpus).
      if (c.front && c.id.length === 1 && me.id.length > 1 && compat(c.id[0], me.id[0]) &&
          (!c.line.length || sameSet(c.line, me.id))) return true;
      return !!loose && c.id.length === 1 && subset(c.id, me.id);
    }
    if (me.alts && c.alts) return c.alts.some(function (x) { return me.alts.some(function (y) { return seqEq(x, y); }); });
    return false;
  }
  function lineMatch(c, me) {
    return !(me.lineKey && c.lineKey) || c.lineKey === me.lineKey;
  }
  function interleave(list) {
    var groups = {}, order = [], out = [];
    list.forEach(function (a) { if (!groups[a.typeWord]) { groups[a.typeWord] = []; order.push(a.typeWord); } groups[a.typeWord].push(a); });
    var left = list.length;
    while (left) order.forEach(function (g) { if (groups[g].length) { out.push(groups[g].shift()); left--; } });
    return out;
  }
  function uniq(list) {
    var seenH = {}, seenT = {};
    return list.filter(function (a) {
      var k = normTitle(a.p.title) + '|' + a.id.join('+');
      if (seenH[a.p.handle] || seenT[k]) return false;
      seenH[a.p.handle] = seenT[k] = 1;
      return true;
    });
  }
  // cur, pool: rohe Produkte (siehe analyse). Liefert { me, series:[…], sets:[…] } mit Begründung je Treffer.
  function recommend(cur, pool, opts) {
    opts = opts || {};
    var N1 = opts.maxSeries || 15, N2 = opts.maxSets || 12;
    var me0 = analyse(cur);
    if (!me0.serie) return { me: me0, reason: 'keine Serie im Titel', series: [], sets: [] };
    var first = pool.map(function (p) { return analyse(p); });
    var names = nameWordsOf(first.concat([me0]), me0.serie);
    var me = analyse(cur, names);
    var all = pool.map(function (p) { return analyse(p, names); })
      .filter(function (a) { return a.p.handle !== cur.handle && a.serie === me.serie && normTitle(a.p.title) !== normTitle(cur.title); });
    var res = { me: me, names: names, series: [], sets: [] };
    if (!all.length) { res.reason = 'Serie nicht bestätigt (kein weiteres Produkt)'; return res; }
    var avail = function (a, b) { return (b.p.available ? 1 : 0) - (a.p.available ? 1 : 0); };

    // Reihe 1: Einzelmodule, gleiche Linie + gleiche Farbe
    if (me.id.length || me.alts) {
      // Zweifarbige Module in der Serie (Sorento: „Grün / Eiche“ = Front / Korpus) → nur exakt gleiche, geordnete
      // Identität. Einfarbige Serie (Langen) → ein Set darf seine Teilfarben zeigen.
      var smods = all.filter(function (a) { return a.kind === 'module' && a.id.length; });
      var twoTone = smods.filter(function (a) { return a.id.length > 1; }).length >= Math.max(3, smods.length * 0.25);
      var loose = me.kind === 'set' && !twoTone;
      var mods = uniq(all.filter(function (a) { return a.kind === 'module' && lineMatch(a, me) && colourMatch(a, me, loose); }));
      res.twoTone = twoTone;
      mods.sort(avail);
      res.series = interleave(mods).slice(0, N1).map(function (a) {
        return { a: a, why: 'Serie ' + a.serie + ', Farbe ' + (a.id.join(' + ') || (a.alts || []).map(function (x) { return x.join('+'); }).join(' | ')) + ' ⊆ ' + (me.id.join(' + ') || 'Varianten') + ', Modul' };
      });
    } else res.reasonSeries = 'Farbe/Dekor nicht sicher bestimmbar';

    // Reihe 2: Sets derselben Serie
    var used = {};
    res.series.forEach(function (x) { used[x.a.p.handle] = 1; });
    var sets = uniq(all.filter(function (a) { return a.kind === 'set' && !used[a.p.handle]; }));
    var same = function (a) { return me.id.length && a.id.length && seqEq(a.id, me.id); };
    // Breitenabstand nur Set ↔ Set (ein 80-cm-Schrank ist kein Maßstab für Küchen)
    var dist = function (a) { return me.kind === 'set' && me.width && a.width ? Math.abs(a.width - me.width) / me.width : 9; };
    var overlap = function (a) { return me.id.filter(function (x) { return a.id.some(function (y) { return compat(x, y); }); }).length; };
    var ranked = sets.map(function (a, i) {
      var pr, why;
      if (me.kind === 'set') {
        if (me.family && a.family === me.family && !same(a)) { pr = 1; why = 'gleiches Modell ' + me.family + ', andere Farbe'; }
        else if (!same(a) && dist(a) <= 0.15) { pr = 2; why = 'ähnliche Breite (' + a.width + ' ↔ ' + me.width + ' cm), andere Farbe'; }
        else { pr = 3; why = same(a) ? 'anderes Modell, gleiche Farbe' : 'anderes Modell der Serie'; }
      } else {
        var share = me.id.some(function (x) { return a.id.some(function (y) { return compat(x, y); }); });
        var inSet = me.id.length && a.id.length && (seqEq(me.id, a.id) || (me.id.length === 1 && subset(me.id, a.id)));
        if (inSet && lineMatch(a, me)) { pr = 1; why = 'Set derselben Linie in dieser Farbe'; }
        else if (share) { pr = 2; why = 'Set mit gemeinsamer Farbe (' + a.id.join(' + ') + ')'; }
        else { pr = 3; why = 'Set der Serie, andere Farbe'; }
      }
      return { a: a, pr: pr, why: why, i: i };
    });
    ranked.sort(function (x, y) {
      if (x.pr !== y.pr) return x.pr - y.pr;
      if (x.pr === 3 && same(x.a) !== same(y.a)) return same(x.a) ? -1 : 1;
      var dd = dist(x.a) - dist(y.a);
      if (dd) return dd;
      // Gleichstand: mehr gemeinsame Farb-/Dekor-Komponenten zuerst (Reihenfolge egal, nur Sortierung –
      // Zugehörigkeit zu P1/P2/P3 bleibt unverändert). „Grau / Artisan“ vor „Grau“ vor „Beige“.
      var ov = overlap(y.a) - overlap(x.a);
      if (ov) return ov;
      return avail(x.a, y.a) || x.i - y.i;
    });
    res.sets = ranked.slice(0, N2).map(function (x) { return { a: x.a, pr: 'P' + x.pr, why: x.why }; });
    return res;
  }

  /* ── Browser: Feed + Karten laden, Reihen füllen ───────────────────── */
  var CACHE_MS = 10 * 60 * 1000;
  function cacheGet(k) {
    try { var v = JSON.parse(sessionStorage.getItem(k)); return v && Date.now() - v.t < CACHE_MS ? v.d : null; } catch (e) { return null; }
  }
  function cacheSet(k, d) { try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }
  function base() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function sectionUrl(section, q, page) {
    return base() + 'search?type=product&section_id=' + section + '&q=' + encodeURIComponent(q) + (page > 1 ? '&page=' + page : '');
  }
  function getText(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
  }
  function retry(fn) {
    return fn().catch(function () { return new Promise(function (r) { setTimeout(r, 600); }).then(fn); });
  }
  function feedPage(q, page) {
    return retry(function () { return getText(sectionUrl('milaros-rel-feed', q, page)); }).then(function (html) {
      var m = html.match(/<script type="application\/json" data-rel-feed>([\s\S]*?)<\/script>/);
      return m ? JSON.parse(m[1]) : { total: 0, pages: 1, items: [] };
    });
  }
  function toProduct(r) {
    return { id: r[0], handle: r[1], title: r[2], type: r[3], available: !!r[4], colours: r[5] ? String(r[5]).split('|') : [], breite: r[6] || '', desc: r[7] || '' };
  }
  function loadFeed(serieRaw) {
    var q = 'title:' + serieRaw, key = 'mlrel:feed:' + q.toLowerCase();
    var hit = cacheGet(key);
    if (hit) return Promise.resolve({ items: hit, requests: 0 });
    return feedPage(q, 1).then(function (f) {
      var pages = Math.min(f.pages || 1, 3), rest = [];
      for (var i = 2; i <= pages; i++) rest.push(feedPage(q, i));
      return Promise.all(rest).then(function (more) {
        var items = f.items.concat.apply(f.items, more.map(function (x) { return x.items; }));
        cacheSet(key, items);
        return { items: items, requests: 1 + rest.length };
      });
    });
  }
  function clean(el) {
    el.classList.remove('ml-reveal');
    [].forEach.call(el.querySelectorAll('[href*="/products/"]'), function (n) { n.setAttribute('href', n.getAttribute('href').split('?')[0]); });
    [].forEach.call(el.querySelectorAll('[data-ml-share]'), function (n) { n.setAttribute('data-ml-share', n.getAttribute('data-ml-share').split('?')[0]); });
    return el;
  }
  function loadCards(ids) {
    if (!ids.length) return Promise.resolve({});
    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    return retry(function () { return getText(sectionUrl('milaros-rel-cards', q, 1)); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), map = {};
      [].forEach.call(doc.querySelectorAll('[data-rel-card]'), function (w) {
        var card = w.querySelector('.ml-pcard');
        if (card) map[w.getAttribute('data-rel-card')] = clean(card);
      });
      return map;
    });
  }
  function fill(sec, list, cards) {
    var rail = sec.querySelector('.mip-rail'), n = 0;
    if (!rail) return 0;
    var frag = document.createDocumentFragment();
    list.forEach(function (x) { var el = cards[x.a.p.handle]; if (el) { frag.appendChild(el); n++; } });
    if (!n) return 0;
    rail.innerHTML = '';
    rail.appendChild(frag);
    var row = sec.querySelector('[data-row]');
    if (row) row.scrollLeft = 0;
    sec.hidden = false;
    return n;
  }
  function run(root) {
    var s1 = root.querySelector('[data-mip-series]');
    var s2 = root.querySelector('[data-mip-alt]');
    var src = s1 || s2;
    if (!src || !window.fetch || !window.DOMParser) return;
    var cur, data = root.querySelector('script[data-rel-product]');
    try { cur = JSON.parse(data.textContent); } catch (e) { return; }
    var t0 = (window.performance && performance.now()) || 0;
    var state = { requests: 0 };
    api.last = state;
    var parsed = parseTitle(cur.title);
    if (!parsed.serie) { state.reason = 'keine Serie'; done(); return; }
    loadFeed(parsed.raw).then(function (feed) {
      state.requests += feed.requests;
      var r = recommend(cur, feed.items.map(toProduct), {
        maxSeries: +(s1 && s1.getAttribute('data-rel-max')) || 15,
        maxSets: +(s2 && s2.getAttribute('data-rel-max')) || 12
      });
      state.result = r;
      var ids = r.series.concat(r.sets).map(function (x) { return x.a.p.id; });
      return loadCards(ids).then(function (cards) {
        if (ids.length) state.requests += 1;
        state.painted = { series: s1 ? fill(s1, r.series, cards) : 0, sets: 0 };
        if (s2 && r.sets.length) {
          state.painted.sets = fill(s2, r.sets, cards);
          if (state.painted.sets) {
            var sub = s2.querySelector('[data-mip-alt-sub]');
            if (sub) {
              sub.textContent = r.me.kind === 'set' ? 'Komplette Lösungen der Serie ' + r.me.raw + ' – in weiteren Farben und Maßen'
                : 'Komplette Lösungen der Serie ' + r.me.raw;
              sub.hidden = false;
            }
          }
        }
      });
    }).catch(function (e) { state.error = String(e && e.message || e); }).then(done);
    function done() {
      state.ms = Math.round(((window.performance && performance.now()) || 0) - t0);
      root.setAttribute('data-rel-done', '1');
      document.dispatchEvent(new CustomEvent('ml:rerender'));
    }
  }
  var api = {
    parseTitle: parseTitle, components: components, analyse: analyse, recommend: recommend,
    kindOf: kindOf, modelOf: modelOf, widthOf: widthOf, subset: subset, sameSet: sameSet, seqEq: seqEq, run: run
  };
  if (typeof document !== 'undefined') {
    var start = function () {
      var root = document.querySelector('[data-mip]');
      if (root) setTimeout(function () { run(root); }, 0);
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
  }
  return api;
});
